import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    const { $pinia, ssrContext } = useNuxtApp()
    const req = ssrContext?.event?.node?.req
    const isCypressUser = req && req.headers['user-agent'] == 'lendioCypressTestUser'
    useRootStore($pinia).$patch({ isCypressUser })
  }
});
